import { createFileRoute } from "@tanstack/react-router";
import { FavoritesPage } from "@/features/favorites/components/FavoritesPage";

export const Route = createFileRoute("/favorites")({
  component: FavoritesPage,
});
